import React from "react";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../utils/letters";
import useAcademicRuns from "../../../hooks/useAcademicRuns";

/* Patrones con colores del frontend (global.css: light-blue, lilac, green, yellow) */
const CARD_PATTERNS = [
	"repeating-linear-gradient(45deg, #c7ddf6 0, #c7ddf6 1px, transparent 1px, transparent 14px)",
	"repeating-linear-gradient(-45deg, #dac0f1 0, #dac0f1 1px, transparent 1px, transparent 14px)",
	"repeating-linear-gradient(90deg, #c0e190 0, #c0e190 1px, transparent 1px, transparent 14px)",
	"repeating-linear-gradient(0deg, #f4d699 0, #f4d699 1px, transparent 1px, transparent 14px)",
];

function formatDate(d) {
	if (!d) return "";
	try {
		return new Date(d).toLocaleDateString("es-CL", { day: "2-digit", month: "short", year: "numeric" });
	} catch {
		return d;
	}
}

export default function TeacherDashboard() {
	const { runs, loading, error } = useAcademicRuns({ role: "teacher" });

	if (loading) {
		return (
			<div className="loader-container">
				<img src="/icon/carga-puntos.svg" alt="Cargando..." style={{ width: '180px' }} />
				<p className="txt-loading">Cargando cursos...</p>
			</div>
		);
	}
	if (error) {
		return (
			<div className="teacher-page teacher-dashboard">
				<div className="alert alert-danger teacher-dashboard-error"><span>{error}</span></div>
			</div>
		);
	}

	return (
		<div className="teacher-page teacher-course-page p-4 backoffice-tables flex-grow-1 overflow-auto font-n">
			<div className="teacher-dashboard-header">
				<h1 className="teacher-dashboard-title">Mis cursos</h1>
			</div>
			<div className="academic-runs-panel p-2 py-4">
				<div className="academic-runs-grid academic-runs-grid--teacher">
					{runs.map((run, index) => (
						<Link
							key={run.id}
							to={`/portal-doc/cursos/${run.id}`}
							className="academic-run-card academic-run-card--teacher"
						>
							<div className="academic-run-card-media">
								{run.image ? (
									<img src={run.image} alt={capitalizeFirstLetter(run.name) || run.code || `Curso ${run.id}`} />
								) : (
									<div
										className="academic-run-card-media-fallback"
										style={{ backgroundImage: CARD_PATTERNS[index % CARD_PATTERNS.length] }}
									>
										<i className="ri-book-2-line" aria-hidden />
									</div>
								)}
							</div>
							<div className="academic-run-card-body">
								<h3 className="academic-run-card-title">
									{capitalizeFirstLetter(run.name) || run.code || `Curso ${run.id}`}
								</h3>
								{run.code && run.name && (
									<p className="academic-run-card-code">{run.code}</p>
								)}
								<div className="academic-run-card-meta academic-run-card-meta--teacher">
									{run.start_date && (
										<span><i className="ri-calendar-line" aria-hidden /> Inicio: {formatDate(run.start_date)}</span>
									)}
									{run.end_date && (
										<span><i className="ri-calendar-check-line" aria-hidden /> Fin: {formatDate(run.end_date)}</span>
									)}
								</div>
								<div className="academic-run-card-cta">
									<span>Gestionar curso</span>
									<i className="ri-arrow-right-line" aria-hidden />
								</div>
							</div>
						</Link>
					))}
				</div>
			</div>
			{runs.length === 0 && (
				<div className="teacher-dashboard-empty">
					<div className="teacher-dashboard-empty-icon">
						<i className="ri-book-open-line" aria-hidden />
					</div>
					<h3 className="teacher-dashboard-empty-title">Sin cursos asignados</h3>
					<p className="teacher-dashboard-empty-text">
						Cuando te asignen cursos, aparecerán aquí. Contacta al administrador si crees que deberías tener acceso.
					</p>
				</div>
			)}
		</div>
	);
}
